module.exports = __webpack_public_path__ + "images/emoji/gem.7c879f3d02703c3b200e.png";